import UserEditTabs from "./user-edit-tabs";

export default UserEditTabs;